import { useContext } from 'react';

import UserContext from '../UserProvider/UserContext';

const useAccount = () => useContext(UserContext);

export default useAccount;
